export const APKS_REQ_INSTALL_START = 'APKS_REQ_INSTALL_START';
export const APKS_REQ_INSTALL_SUCCESS = 'APKS_REQ_INSTALL_SUCCESS';
export const APKS_REQ_INSTALL_FAILURE = 'APKS_REQ_INSTALL_FAILURE';

export const APKS_REQ_INSTALL_LIST_START = 'APKS_REQ_INSTALL_LIST_START';
export const APKS_REQ_INSTALL_LIST_SUCCESS = 'APKS_REQ_INSTALL_LIST_SUCCESS';
export const APKS_REQ_INSTALL_LIST_FAILURE = 'APKS_REQ_INSTALL_LIST_FAILURE';

export const APKS_REQ_UNINSTALL_START = 'APKS_REQ_UNINSTALL_START';
export const APKS_REQ_UNINSTALL_SUCCESS = 'APKS_REQ_UNINSTALL_SUCCESS';
export const APKS_REQ_UNINSTALL_FAILURE = 'APKS_REQ_UNINSTALL_FAILURE';

export const APKS_REQ_PKG_LIST_START = 'APKS_REQ_PKG_LIST_START';
export const APKS_REQ_PKG_LIST_SUCCESS = 'APKS_REQ_PKG_LIST_SUCCESS';
export const APKS_REQ_PKG_LIST_FAILUR = 'APKS_REQ_PKG_LIST_FAILUR';

export const APKS_REQ_RUN_START = 'APKS_REQ_RUN_START';
export const APKS_REQ_RUN_SUCCESS = 'APKS_REQ_RUN_SUCCESS';
export const APKS_REQ_RUN_FAILURE = 'APKS_REQ_RUN_FAILURE';

export const APKS_REQ_CANCEL_INSTALL_START = 'APKS_REQ_CANCEL_INSTALL_START';
export const APKS_REQ_CANCEL_INSTALL_SUCCESS = 'APKS_REQ_CANCEL_INSTALL_SUCCESS';
export const APKS_REQ_CANCEL_INSTALL_FAILURE = 'APKS_REQ_CANCEL_INSTALL_FAILURE';
